export const ForesightSupportEmail = 'support@foresightdata.com';
